import isotope from 'isotope-layout';


function radioButtonGroup(buttonGroup) {
    buttonGroup.addEventListener('click', function (event) {
        // only work with anchor tags
        if (!event.target.matches('a')) {
            return;
        }
        buttonGroup.querySelector('.is-active').classList.remove('is-active');
        event.target.classList.add('is-active');
    });
}

const init = () => {
    const iso = new isotope('.StudentTestimonailList', {
        itemSelector: '.student-testimonail-card',
        layoutMode: 'fitRows'
    });

    /*/ bind filter button click*/
    var filtersElem = document.querySelector('.student-testimonials-tabs');
    if (filtersElem) {
        filtersElem.addEventListener('click', function (event) {
            // only work with anchor tags
            if (!event.target.matches('a')) {
                return;
            }
            var filterValue = event.target.getAttribute('data-filter');
            iso.arrange({ filter: filterValue });
        });

        // change is-checked class on buttons
        var buttonGroups = document.querySelectorAll('.student-testimonials-tabs');
        for (var i = 0, len = buttonGroups.length; i < len; i++) {
            var buttonGroup = buttonGroups[i];
            radioButtonGroup(buttonGroup);
        }
    }
};

const testimonialFilter = { init };
export default testimonialFilter;
